import type { ComponentType, SVGProps } from 'react';
import {
    AmexLogo,
    ApplePayWhiteLogo,
    ClearPayLogo,
    GPayLogo,
    KlarnaLogo,
    MaestroLogo,
    MastercardLogo,
    PaypalLogo,
    SamsungLogo,
} from '@/shared-ui/icons/payment-methods';

export const PAYMENT_METHOD_IDS = [
    'amex',
    'apple-pay-white',
    'maestro',
    'clearpay',
    'gpay',
    'klarna',
    'mastercard',
    'paypal',
    'samsung-pay',
] as const;

export type PaymentMethodId = (typeof PAYMENT_METHOD_IDS)[number];

export const PAYMENT_METHOD_LABELS: Record<PaymentMethodId, string> = {
    amex: 'American Express',
    'apple-pay-white': 'Apple Pay',
    maestro: 'Maestro',
    clearpay: 'Clearpay',
    gpay: 'Google Pay',
    klarna: 'Klarna',
    mastercard: 'Mastercard',
    paypal: 'PayPal',
    'samsung-pay': 'Samsung Pay',
};

export const PAYMENT_METHOD_ICONS: Record<PaymentMethodId, ComponentType<SVGProps<SVGSVGElement>>> = {
    amex: AmexLogo,
    'apple-pay-white': ApplePayWhiteLogo,
    maestro: MaestroLogo,
    clearpay: ClearPayLogo,
    gpay: GPayLogo,
    klarna: KlarnaLogo,
    mastercard: MastercardLogo,
    paypal: PaypalLogo,
    'samsung-pay': SamsungLogo,
};

export function isPaymentMethodId(value: string): value is PaymentMethodId {
    return (PAYMENT_METHOD_IDS as readonly string[]).includes(value);
}
